import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

export const connectMatchStats = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }

  return connect(mapStateToProps, mapDispatchToProps)(component)
}
